export default __webpack_public_path__ + "files/4651fd92bdc643485b9edc86e79e02e7.jpg";